import { Environment } from 'src/app/shared/config/environments';
import { ENVIRONMENT } from 'src/app/shared/constants/configObjectProperties';
import { getConfig } from 'src/app/utils/config';

export const isProd = () => getConfig(ENVIRONMENT) === Environment.PROD;
export const isStaging = () => getConfig(ENVIRONMENT) === Environment.STAGING;
export const isDev = () => getConfig(ENVIRONMENT) === Environment.DEV;

// @ts-ignore
export const isEnvMocked = () => global.USE_STAGING_ENV_FOR_LOCAL !== 'true';

export const getEnvironment = (): Environment =>
  getConfig(ENVIRONMENT, Environment.DEV);

export const isServerRendering = () => typeof window === 'undefined';
